module.exports = __webpack_public_path__ + "img/img_assistant_img2.e0512c53.png";